import { useQuery } from '@tanstack/react-query';
import { listAnnouncements } from 'services';
import { queryKeys } from './config/queryClient';

/**
 * Fetch announcements data
 */
const fetchAnnouncements = async (pageLimit) => {
  try {
    const response = await listAnnouncements(pageLimit);
    return response?.data || { announcements: [], next_token: null };
  } catch (error) {
    console.error('Error fetching announcements:', error);
    // Return empty data structure on error
    return { announcements: [], next_token: null };
  }
};

/**
 * Hook to fetch announcements using React Query
 * Data is never considered stale (staleTime: Infinity)
 *
 * @param {number} pageLimit - Number of announcements to fetch (default: 20)
 * @returns {Object} { data, loading, error, refetch }
 */
export const useAnnouncements = (pageLimit = 20) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.announcements.list(pageLimit),
    queryFn: () => fetchAnnouncements(pageLimit),
    staleTime: Infinity, // Data never becomes stale
    gcTime: Infinity, // Keep in cache indefinitely
    retry: 2,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  return {
    data: data || { announcements: [], next_token: null },
    loading: isLoading,
    error,
    refetch,
  };
};
